export const selectCardMovements = state => state.cardMovements;

export const selectCardMovementsList = state =>
  selectCardMovements(state).items;

export const selectCardMovementsCount = state =>
  selectCardMovements(state).count;

export const selectCardMovementsQueryOptions = state => {
  const { options } = selectCardMovements(state);

  Object.keys(options).forEach(key => {
    if (options[key] === '') {
      delete options[key];
    }
  });

  return options;
};
